var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarregando(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "circleIconState",
    d: "M17.5 35C27.165 35 35 27.165 35 17.5C35 7.83502 27.165 0 17.5 0C7.83502 0 0 7.83502 0 17.5C0 27.165 7.83502 35 17.5 35Z",
    fill: "#C7B301"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0437 17.6209L29.646 9.6499H20.4414L25.0437 17.6209Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9375 25.3499H9.94598V13.3245H5.9375V25.3499ZM18.631 20.0053L16.5867 19.3238L17.0677 17.9743L18.631 18.6691H22.1317C22.7865 18.6691 23.3076 18.148 23.3076 17.4933C23.3076 16.9989 23.0003 16.558 22.5326 16.3843L13.9545 13.3245H11.9502V23.1586L19.9672 25.3499L28.6522 22.0095C28.6522 20.9005 27.757 20.0053 26.648 20.0053H18.631Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarregando);
export default __webpack_public_path__ + "static/media/carregando.44691a3d371df790c7208d36e89f26d2.svg";
export { ForwardRef as ReactComponent };